import BasePhone from './BasePhone'
import { Field } from 'formik'

const Phone = ({formik, ...props}) => {
    if (formik) {
        return <Field name={props.name}>
            {({field, form}) => {
                return (
                    <BasePhone
                        {...props}
                        {...field}
                        onChange={(value, data) => {
                            field.onChange({target: {value, name: props.name}})
                            field.onChange({target: {value: value.slice(data.dialCode.length), name: props.name + '_number'}})
                            field.onChange({target: {value: data.dialCode, name: props.name + '_prefix'}})
                            field.onChange({target: {value: data.countryCode, name: props.name + '_country'}})
                        }}
                        error={form?.touched[props.name] && form?.errors[props.name]}
                    />
                )
            }}
        </Field>
    }
    
    return (
        <BasePhone {...props} />
    )
}

export default Phone